import {
  Component,
  EventEmitter,
  inject,
  Injectable,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CustomerService } from 'src/app/services/customer.service';
import { FenceService } from 'src/app/services/configurators-2d/applications/fence.service';
import { BaseConfigurator } from '../configurator/base-configurator';
import { ConfiguratorStructure } from '../configurator/configurator-structure';
import {
  FE_ENVIRONMENT,
  FE_CONFIGURATION,
  FE_MATERIALS,
  FE_ACCESSORIES,
  FE_SUMMARY,
} from 'src/app/providers/fence.providers';
import { Configuration } from 'src/app/models/configurators-2d/applications/fence/configuration';
import { FencePreviewComponent } from './preview/preview.component';
import { rotateImg } from 'src/app/services/helpers/fence-helper';
import { Decoration } from 'src/app/models/configurators-2d/applications/fence/decoration';
import { DataLoaderService } from './services/data-loader.service';

@Component({
  selector: 'ng-fence-configuration',
  templateUrl: './fence.component.html',
})
@Injectable()
export class FenceComponent extends BaseConfigurator<Configuration, FenceService> implements OnInit, OnDestroy {
  //Etape de la configuration
  @Input() step: number = 1;

  //Sous-étape de l'étape finitions
  subStep: number = 1;

  @Output() setGlobalLoading: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() getFinishesStep: EventEmitter<any> = new EventEmitter<boolean>();

  @ViewChild(FencePreviewComponent) fencePreview: FencePreviewComponent;

  private readonly dataLoaderService = inject(DataLoaderService);

  constructor(
    public customer: CustomerService,
    private route: ActivatedRoute,
    fenceService: FenceService,
    injector: Injector
  ) {
    super(fenceService, injector);
  }

  ngOnInit(): void {
    let that = this;
    this.loadExistingConfigurationIfNeeded(this.route).then(() => {
      if (!this.configuration) {
        that.setGlobalLoading.emit(false);
        return;
      }

      for (let j = 0; j < this.configuration.sides?.length; j++) {
        if (this.configuration.sides[j].verticalDecorativeBoards) {
          this.addVerticalPath(this.configuration.sides[j].verticalDecorativeBoards);
        }
      }

      for (let j = 0; j < this.configuration.sides?.length; j++) {
        if (this.configuration.sides[j].verticalDecorations) {
          this.addVerticalPath(this.configuration.sides[j].verticalDecorations);
        }
      }

      for (let j = 0; j < this.configuration.sides?.length; j++) {
        if (this.configuration.sides[j].verticalPanels) {
          this.addVerticalPath(this.configuration.sides[j].verticalPanels);
        }
      }

      if (this.configuration.horizontalDecorativeBoards) {
        this.addVerticalPath(this.configuration.horizontalDecorativeBoards);
      }

      if (this.configuration.horizontalDecorations) {
        this.addVerticalPath(this.configuration.horizontalDecorations);
      }

      if (this.configuration.horizontalPanels) {
        this.addVerticalPath(this.configuration.horizontalPanels);
      }

      this.dataLoaderService.initData().subscribe(() => {
        that.setGlobalLoading.emit(false);
      });
    });
  }

  ngOnDestroy() {
    this.service.reset();
  }

  override initConfigurator(): ConfiguratorStructure {
    return new ConfiguratorStructure([
      {
        index: 1,
        title: 'fence.steps.environment',
        injectionToken: FE_ENVIRONMENT,
        gtmTitle: 'Cloture | Votre Environnement',
        gtmPageName: 'votre-environnement',
      },
      {
        index: 2,
        title: 'fence.steps.configuration',
        injectionToken: FE_CONFIGURATION,
        gtmTitle: 'Cloture | Mesures',
        gtmPageName: 'mesures',
      },
      {
        index: 3,
        title: 'fence.steps.materials',
        injectionToken: FE_MATERIALS,
        gtmTitle: 'Cloture | Matériaux et décorations',
        gtmPageName: 'materiaux-et-decorations',
      },
      {
        index: 4,
        title: 'fence.steps.accessories',
        injectionToken: FE_ACCESSORIES,
        gtmTitle: 'Cloture | Accessoires',
        gtmPageName: 'accessoires',
      },
      {
        index: 5,
        title: 'fence.steps.summary',
        injectionToken: FE_SUMMARY,
        gtmTitle: 'Cloture | Prix et Résumé',
        gtmPageName: 'prix-et-resume',
      },
    ]);
  }

  addVerticalPath(decors: Decoration[]): void {
    for (let i = 0; i < decors.length; i++) {
      if (decors[i].quantity > 0) {
        rotateImg(this.service.imgPath(decors[i].path), 270).then((res: string) => {
          decors[i].verticalPath = res;
        });
      }
    }
  }
}
